import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=2a76494c&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=2a76494c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a76494c",
  null
  
)

export default component.exports